// extracted by mini-css-extract-plugin
export var actionButton = "_wv-2";
export var card = "_wv-0";
export var disambiguationList = "_wv-3";
export var errorCard = "_wv-4";
export var row = "_wv-1";